import { render, staticRenderFns } from "./PopupInputGroupIngredientsConfirmation.vue?vue&type=template&id=4db614be"
import script from "./PopupInputGroupIngredientsConfirmation.vue?vue&type=script&lang=js"
export * from "./PopupInputGroupIngredientsConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports